/**
 * Application.Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type TradingState =
  | 'Unknown'
  | 'AbbAuction'
  | 'Adjust'
  | 'AdjustOn'
  | 'Close'
  | 'Cspa'
  | 'Enquire'
  | 'LateTrading'
  | 'Open'
  | 'OpenNightTrading'
  | 'PreCspa'
  | 'PreNightTrading'
  | 'PreNr'
  | 'PreOpen'
  | 'PurgeOrders'
  | 'Suspend'
  | 'TradingHalt'
  | 'InOpen'
  | 'AfterHoursAdjust'
  | 'RegulatoryHalt'
  | 'OpenQuoteDisplay'
  | 'OpenVmb'
  | 'WaitVmb'
  | 'InternationalHalt'
  | 'PreTrade'
  | 'PostTrade';

export const TradingState = {
  Unknown: 'Unknown' as TradingState,
  AbbAuction: 'AbbAuction' as TradingState,
  Adjust: 'Adjust' as TradingState,
  AdjustOn: 'AdjustOn' as TradingState,
  Close: 'Close' as TradingState,
  Cspa: 'Cspa' as TradingState,
  Enquire: 'Enquire' as TradingState,
  LateTrading: 'LateTrading' as TradingState,
  Open: 'Open' as TradingState,
  OpenNightTrading: 'OpenNightTrading' as TradingState,
  PreCspa: 'PreCspa' as TradingState,
  PreNightTrading: 'PreNightTrading' as TradingState,
  PreNr: 'PreNr' as TradingState,
  PreOpen: 'PreOpen' as TradingState,
  PurgeOrders: 'PurgeOrders' as TradingState,
  Suspend: 'Suspend' as TradingState,
  TradingHalt: 'TradingHalt' as TradingState,
  InOpen: 'InOpen' as TradingState,
  AfterHoursAdjust: 'AfterHoursAdjust' as TradingState,
  RegulatoryHalt: 'RegulatoryHalt' as TradingState,
  OpenQuoteDisplay: 'OpenQuoteDisplay' as TradingState,
  OpenVmb: 'OpenVmb' as TradingState,
  WaitVmb: 'WaitVmb' as TradingState,
  InternationalHalt: 'InternationalHalt' as TradingState,
  PreTrade: 'PreTrade' as TradingState,
  PostTrade: 'PostTrade' as TradingState
};
